const MODES = [
  { value: 'ZONE', name: '功能分区' }, { value: 'POPULATION', name: '人口密度热力' },
  { value: 'ECONOMY', name: '经济水平热力' }, { value: 'RISK', name: '公共安全风险' },
  { value: 'GRID', name: '网格划分视图' }
]
const simpleName = name => String(name || '').replace(/热力|视图/g, '')

// Legacy string layers and maps without layer metadata keep their old defaults.
export function mapDisplayModes (layers) {
  const configured = Array.isArray(layers) ? layers : []
  const result = MODES.filter(mode => {
    const layer = configured.find(item => typeof item === 'string'
      ? simpleName(item) === simpleName(mode.name)
      : item && (item.code === mode.value || simpleName(item.name) === simpleName(mode.name)))
    return !layer || typeof layer === 'string' || layer.visible !== false
  })
  return result.length ? result : [{ value: 'BASE', name: '基础底图' }]
}

export function visibleMapMode (layers, requested) {
  const modes = mapDisplayModes(layers)
  return modes.some(mode => mode.value === requested) ? requested : modes[0].value
}
